import { render, staticRenderFns } from "./InstitutionsInfos.vue?vue&type=template&id=3800e617&scoped=true&"
import script from "./InstitutionsInfos.vue?vue&type=script&lang=js&"
export * from "./InstitutionsInfos.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionsInfos.vue?vue&type=style&index=0&id=3800e617&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3800e617",
  null
  
)

export default component.exports